const VERSION: string = '0.1.7-prod.12'
export default VERSION;
